import { createReducer } from '@ngrx/store';

export const addProspectReducer = createReducer({});
